import clsx from "clsx";

interface FormInputErrorMessageProps
  extends Omit<React.ComponentProps<"div">, "aria-live"> {
  children: React.ReactNode;
  id: string;
  ariaLive?: React.AriaAttributes["aria-live"];
  className?: string;
}

export function FormInputErrorMessage({
  children,
  id,
  ariaLive = "assertive",
  className,
}: FormInputErrorMessageProps) {
  return (
    <div
      id={id}
      className={clsx("mt-1 text-xs text-red-600", className)}
      aria-live={ariaLive}
    >
      {children && <span>{children}</span>}
    </div>
  );
}
